import axios from 'axios';
import queryString from 'query-string';
import {call, delay, put} from 'redux-saga/effects';

import {
    authenticationError,
    exchangeToken,
    receiveAuthenticationToken,
    setLoginState
} from 'modules/authentication/actions';
import {loginStates, oauth2RedirectUrl} from 'modules/authentication/constants';
import {
    getAuthRedirectDetails,
    setApiToken,
    setAuthRedirectDetails,
    setOAuth2Token,
    setRefreshToken
} from 'modules/authentication/utils';
import {doApiCall} from 'modules/sagaUtils';

export function* authenticateWithOAuth2(username, domain, clientId, identityProvider) {

    setAuthRedirectDetails(username, domain, clientId, identityProvider);

    yield put(setLoginState(loginStates.EXTERNAL));

    yield delay(500);

    const query = {
        response_type: 'code',
        identity_provider: identityProvider,
        client_id: clientId,
        redirect_uri: oauth2RedirectUrl,
    };

    const link = domain + '/oauth2/authorize?' + queryString.stringify(query);

    console.log('redirecting to auth provider', link);
    window.location.href = link;

}

export function* handleOAuth2Redirect(code) {
    if (!code) {
        console.log('Invalid Auth code');
        return false;
    }

    const redirectDetails = getAuthRedirectDetails();
    const username = redirectDetails.username;

    if (!username) {
        // required information was missing
        return false;
    }

    const tokenUrl = redirectDetails.domain + '/oauth2/token';
    const tokenRequestData = {
        grant_type: 'authorization_code',
        code,
        client_id: redirectDetails.clientId,
        redirect_uri: oauth2RedirectUrl,
    };

    const tokenRequestConfig = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    };

    let tokenResponse;
    try {
        tokenResponse = yield axios.post(tokenUrl, tokenRequestData, tokenRequestConfig);
    } catch (e) {
        console.log('OAuth2 token request failed');
        return false;
    }

    const refreshToken = tokenResponse.data?.refresh_token

    if (!refreshToken) {
        console.log('No refresh token in the OAuth2 token response');
        return false;
    }

    const accessToken = tokenResponse.data?.access_token;
    const accessTokenTtl = tokenResponse.data?.expires_in;

    setRefreshToken(refreshToken, 86400); // force re-authorisation every day
    setOAuth2Token(accessToken, accessTokenTtl)

    let apiAction;
    try {
        apiAction = yield call(
            doApiCall,
            exchangeToken,
            {username, token: accessToken, expiry: Date.now() + accessTokenTtl},
            {tokenType: 'oauth2'},
            receiveAuthenticationToken,
            authenticationError,
        );
    } catch (e) {
        console.log('token exchange error', e);
        return false;
    }

    const token = apiAction?.payload?.data?.token;
    const ttl = apiAction?.payload?.data?.ttl;

    if (!token) {
        return false;
    }

    console.log('token expires in', ttl);
    setApiToken(token, ttl);

    return username;
}
